import type { UUID } from "@/core/types";

export const usePatientConsentsKey = {
  base: ["patientConsents"] as const,
  list: (patientId: UUID) => [...usePatientConsentsKey.base, patientId] as const,
};

export const usePolicyMetadataKey = {
  base: ["policyMetadata"] as const,
};
